import { EMAIL, EMAIL_ACTIVITY, TASK, MEETING, CALL, NOTE, INCOMING_EMAIL, FORWARDED_EMAIL, CONVERSATION_SESSION } from 'customer-data-objects/engagement/EngagementTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const deriveNextLastActivities = ({
  notesNextActivityDate,
  notesLastUpdated,
  engagements
}) => {
  const nextLastActivities = {};
  engagements.forEach(engagement => {
    const timestampValue = engagement.properties.hs_timestamp.value;
    if (timestampValue === notesNextActivityDate) {
      nextLastActivities.nextActivity = engagement;
    }
    if (timestampValue === notesLastUpdated) {
      nextLastActivities.lastActivity = engagement;
    }
  });
  return nextLastActivities;
};
export const derivePrefixFromEngagementType = ({
  engagementType,
  isNextActivity
}) => {
  switch (engagementType) {
    case EMAIL:
    case EMAIL_ACTIVITY:
    case INCOMING_EMAIL:
    case FORWARDED_EMAIL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.email"
      });
    case MEETING:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.meeting"
      });
    case NOTE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.note"
      });
    case CALL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.call"
      });
    case CONVERSATION_SESSION:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.chat"
      });
    case TASK:
      return isNextActivity ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.taskDue"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.nextLastActivity.task"
      });
    default:
      return null;
  }
};